var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workspace"},[_c('TopHeader'),_c('Navi'),_c('fluidCover'),_c('fluidBend'),_c('div',{staticClass:"wrapper"},[_c('b-container',[_c('LectureWelcomeBox')],1),_c('b-container',{attrs:{"fluid":""}},[_c('EventBox')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }